// Types
import { Statistics } from './types';

// Services
import { gql } from 'graphql-request';
import { useQuery, UseQueryResult } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useLeadsStatistics = () => {
  const { client } = graphqlConfig();

  const data: UseQueryResult<Statistics, Error> = useQuery<Statistics, Error>(['leads-statistics'], async () => client.request(
    gql`
    query AdminLeadsTotalStat {
      adminLeadsTotalStat {
        TotalLeads
        futureLeads
        futureLeadsRate
        convertedLeads
        convertedLeadsRate
        pendingLeads
        pendingLeadsRate
        lostLeads
        lostLeadsRate
      }
    }
    `,
  ).catch((error) => console.error(error)));
  return data;
};
